const noticeConfirm = (message) => {
    confirm(message);
}

export {
    noticeConfirm
}
